import createHDPPiDataLoaderFn from './data.pi';
import HotelDetailsPagePI from './page.pi';

export { HotelDetailsPagePI };
export { createHDPPiDataLoaderFn };
